// extracted by mini-css-extract-plugin
export default {"container":"LoadingData_container__WS+ho","logoWrapper":"LoadingData_logoWrapper__EpiA1"};